<template>

    <a-card>
        <a-form class="table-search" ref="searchForm" layout="inline" :model="searchForm">
            <a-form-item label="评审名称" name="projectReviewName">
                <a-input style="width: 140px" v-model:value="searchForm.projectReviewName" placeholder="请输入评审名称"/>
            </a-form-item>
            <a-form-item label="评审地点" name="reviewPlace">
                <a-input style="width: 140px" v-model:value="searchForm.reviewPlace" placeholder="请输入评审地点"/>
            </a-form-item>

            <a-form-item label="评审时间" name="reviewPlace">
                <RangePicker v-model:value="dateTime"
                             @change="changeTime"
                             placeholder="请选择时间"/>
            </a-form-item>

            <a-form-item style="margin-right: 0">
                <a-button type="primary" @click="onSearch">查询</a-button>
                <a-button @click="onReset">重置</a-button>
            </a-form-item>
        </a-form>

        <a-alert message="评审时间≥24小时，可自行取消报名；<24小时请联系后台管理员，联系电话：0353-2292730" type="warning" show-icon style="margin-bottom: 8px" />
        <a-table :columns="columns" :pagination="pagination" :data-source="dataSource" :loading="loading" @change="onTableChange">

            <template #projectReviewName="{record, text }">
                <a href="#" @click="showDetail(record)">{{ text }}</a>
            </template>

            <template #reviewStatus="{text }">
                <ReviewStatus :status="text"></ReviewStatus>
            </template>
            <template #meetingMinutes="{ record }">
                <FileUpload v-model:value="record.meetingMinutes" :show-btn="false" disabled></FileUpload>
            </template>
            <template #applicationAttachment="{ record }">
                <FileUpload v-model:value="record.applicationAttachment" :show-btn="false" disabled></FileUpload>
            </template>
            <template #action="{ record }">
                <div v-if="isShowUnReg(record)" class="table-row-operations">
                    <a-popconfirm
                        title="确定要取消报名吗? 提交后无法修改!"
                        ok-text="是"
                        cancel-text="否"
                        @confirm="onCancel(record)"
                        @cancel="()=>{}"
                    >
                        <a>取消报名</a>
                    </a-popconfirm>
                </div>
                <div v-if="record.reviewType!=='0'" class="table-row-operations">
                    <a-button type="link" size="small" :disabled="!record.noCheckAppendFile" @click="downloadNoCheckFile(record)">下载资料</a-button>
                </div>
            </template>
        </a-table>
    </a-card>
    <detail ref="detail"></detail>
</template>

<script>

import {dictMixin, tableListMixin} from "@/mixins";

import {registered} from "@/api/projectReviewService";

import FileUpload from "@/components/form/upload/FileUpload";
import Detail from "./components/Detail";
import ReviewStatus from "./components/ReviewStatus";
// import axios from "axios";
import {file_service} from "@/api/adminService";


const columns = [
    // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
    {
        title: "项目名称",
        dataIndex: "projectReviewName",
        key: "projectReviewName",
        ellipsis: true,
        slots: {customRender: "projectReviewName"}
    },
/*    {
        title: "提报单位",
        dataIndex: "createdBy",
        ellipsis: true,
        key: "createdBy",
    },*/
    {title: "评审状态",width:"100px", dataIndex: "reviewStatus", key: "reviewStatus", slots: {customRender: "reviewStatus"}},
    {title: "评审时间",width:"150px", dataIndex: "reviewTime", key: "reviewTime"},
    {title: "评审地点", dataIndex: "reviewPlace", ellipsis: true, key: "reviewPlace"},

    // {title: "项目概述", ellipsis: true, dataIndex: "projectOverview", key: "projectOverview"},
   /* {title: "会议纪要", dataIndex: "meetingMinutes", key: "meetingMinutes", ellipsis: true,slots: {customRender: "meetingMinutes"}},
    {
        title: "评审内容",
        ellipsis: true,
        dataIndex: "applicationAttachment",
        key: "applicationAttachment",
        slots: {customRender: "applicationAttachment"}
    },*/

    {title: "操作", dataIndex: "action", key: "action", width:"100px",slots: {customRender: "action"}},
];
export default {
    name: "index",
    mixins: [tableListMixin, dictMixin],
    components: {
        ReviewStatus,
        Detail,
        FileUpload,
    },
    data() {
        return {
            columns,
            queryParam: {},
            listUrl: registered.my,
            listKeyField: "id",
            deleteUrl: "",
            dateTime:[]
        }
    },
    methods: {
        onReset(){
            this.dateTime=[]
            this.$refs.searchForm.resetFields();
            this.queryParam = {};
            this.searchForm = {}
            this.loadData(1);
        },
        changeTime(time) {
            this.queryParam.startTime = time[0]
            this.queryParam.endTime = time[1]
        },
        isShowUnReg(record){
            let date = new Date(record.reviewTime);
            let now = new Date();
            //24小时
            return date-now>86400000 && record.reviewStatus==='3';
        },
        showDetail(row){
            let rows = {...row}
            this.onShowModal("detail", rows);
        },
        onCancel(record){
            if (record.reviewStatus==='-1'){
                this.$notification.warning({
                    message: '提示',
                    description: "评审已被取消，无需取消报名。",
                });
                return
            }
            this.postAction({
                url: registered.unReg,
                params: {reviewId: record.id}
            }).then((resp)=>{
                console.log(resp)
                if (resp){
                    this.$notification.success({
                        message: '提示',
                        description: "取消报名成功!",
                    });
                    this.onFormEdited()
                }else{
                    this.$notification.error({
                        message: '提示',
                        description: resp,
                    });
                }
            })
        },
        downloadNoCheckFile(record){
            let appId = record.id;
            let file = record.noCheckAppendFile;
            console.log(appId, file)
            // 发已读
            this.postAction({
                url: registered.read,
                params: {
                    reviewId: appId
                }
            }).then(()=>{
                // 下载
                const link = document.createElement('a');
                link.href = file_service.download+file;
                link.target = "_blank"
                // link.download = file.split("|")[1];
                // link.setAttribute('download', file.split("|")[1]); // 你可以设置文件名
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                /*axios({
                    methods: 'get',
                    url: file_service.download + file,
                    // responseType: 'blob',
                }).then(() => {
                    // const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = file_service.download+file;
                    link.target = "_blank"
                    // link.download = file.split("|")[1];
                    // link.setAttribute('download', file.split("|")[1]); // 你可以设置文件名
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                })*/
            })
        }
    }
}
</script>

<style scoped>
.table-search .ant-input, .table-search .ant-select {
    width: 147px !important;
}
</style>
